import { EyeInvisibleOutlined } from '@ant-design/icons';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { createHiddenWidgetSchema } from './createHiddenWidgetSchema.ts';
import { HiddenWidgetComponent } from './HiddenWidgetComponent.tsx';
import {
  HiddenWidgetConfigComponent,
  HiddenWidgetConfigSchema,
} from './HiddenWidgetConfigComponent.tsx';
import { HiddenWidgetPreviewComponent } from './HiddenWidgetPreviewComponent.tsx';
import { type IHiddenWidget } from './IHiddenWidget.ts';

export const HiddenWidgetType: IWidgetType<IHiddenWidget> = {
  type: WidgetType.Hidden,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo nascosto',
  icon: <EyeInvisibleOutlined />,
  hasValue: true,
  getReference: (path, widget) => {
    return getSimpleWidgetReference(widget.dataType)(path, widget);
  },
  formComponent: HiddenWidgetComponent,
  createFormSchema: createHiddenWidgetSchema,
  previewComponent: HiddenWidgetPreviewComponent,
  configValidator: HiddenWidgetConfigSchema,
  configComponent: HiddenWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [CustomWarningsRule],
  // Non mostrare le regole di visualizzazione
  hideFlags: true,
  dynamicReference: true,
};
